import React, { Fragment, useCallback, useContext, useEffect, useState } from "react";

import NoRatesPlaceholder from "./no_rates_placeholder";
import RatePlan from "./rate_plan";

import { RightOutlined, UpOutlined, DownOutlined } from "@ant-design/icons";
import { Card, Accordion } from "react-bootstrap";
import styles from "./room_type.module.css";

import Description from "./description/description";
import DummyImage from "assets/images/dummy-image-square.jpg";
import RoomFacilities from "./room_info/room_facilities/room_facilities";
import RoomTitle from "./room_info/room_title/room_title";

import applySequentialDiscounts from "utils/applySequentialDiscount";
import { useTranslation } from "react-i18next";
import { formatNumberWithDecimal } from "utils/formatNumberWithDecimels";
import { BookingDataContext } from "containers/data_context";

const DEFAULT_ROOM_RATES = {};

export default function RoomType(props) {
  const {
    roomType,
    currency,

    ratesOccupancyPerRoom,
    adultsOccupancy,
    checkinDate,
    disabled,
    property,
    promotions,
    bookedRatesOccupancy,
    childrenOccupancy,
    disable,
    update,
    onRatesOccupancyChange,
    showBreakFastIncluded,
    setShowLoginModal = () => {},
    isMemberShipEnabled,
  } = props;
  const { channelId } = useContext(BookingDataContext);
  const [occupiedSpaces, setOccupiedSpaces] = useState(0);
  const { t } = useTranslation();
  const [sortedRates, setSortedRates] = useState([]);

  const { ratePlans, id } = roomType;
  const { [id]: roomRates = DEFAULT_ROOM_RATES } = ratesOccupancyPerRoom;
  const { [id]: bookedRoomRates = DEFAULT_ROOM_RATES } = bookedRatesOccupancy;
  const { facilities, description } = roomType;
  const [roomDetailsExpanded, setRoomDetailsExpanded] = useState(false);
  const [priceExpanded, setPriceExpanded] = useState(true);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleModalToggle = useCallback(() => {
    setIsModalOpen(!isModalOpen);
  }, [isModalOpen, setIsModalOpen]);

  const userData = JSON.parse(localStorage.getItem("userInfo"));

  const handleRoomDetailsToggle = () => {
    setRoomDetailsExpanded(!roomDetailsExpanded);
  };

  const handlePriceToggle = () => {
    setPriceExpanded(!priceExpanded);
  };

  const handleRatesOccupancyChange = (updatedRatesOccupancy) => {
    onRatesOccupancyChange({ ...ratesOccupancyPerRoom, [id]: updatedRatesOccupancy });
  };

  useEffect(
    function updateAvailability() {
      const updatedOccupiedSpaces = Object.values(roomRates).reduce((a, b) => a + b, 0);

      setOccupiedSpaces(updatedOccupiedSpaces);
    },
    [roomRates],
  );

  useEffect(
    function updateRatesPlans() {
      if (!Array.isArray(ratePlans)) {
        return;
      }
      const ratesByOccupancyMatch = ratePlans.sort((a, b) => {
        const aOccupancyMatchRating =
          Number(a.occupancy.children === childrenOccupancy) +
          Number(a.occupancy.adults === adultsOccupancy);

        const bOccupancyMatchRating =
          Number(b.occupancy.children === childrenOccupancy) +
          Number(b.occupancy.adults === adultsOccupancy);

        return bOccupancyMatchRating - aOccupancyMatchRating;
      });

      setSortedRates([...ratesByOccupancyMatch]);
    },
    [ratePlans, adultsOccupancy, childrenOccupancy],
  );

  return (
    <div className={styles.roomContainer}>
      <Card className={styles.roundedImage}>
        <div className="row no-gutters">
          <div className="col-md-4 col-sm-4">
            <div onClick={handleModalToggle} className={styles.imageContainer}>
              <Card.Img
                loading="lazy"
                src={
                  roomType.photos.length
                    ? roomType.photos[0].url + "-/scale_crop/1000x900/smart/.jpg"
                    : DummyImage
                }
                alt="Hotel Image"
                className={styles.roundedImage}
              />
              {showBreakFastIncluded && (
                <>
                  <div className={styles.triangle} />
                  <div className={styles.badge}>Breakfast Included</div>
                </>
              )}
            </div>
          </div>
          <div className="col-md-8 d-flex flex-column col-sm-6">
            <Card.Body>
              <Card.Title>
                <RoomTitle
                  handleModalToggle={handleModalToggle}
                  isModalOpen={isModalOpen}
                  setIsModalOpen={setIsModalOpen}
                  promotions={promotions}
                  room={roomType}
                  property={property}
                />
              </Card.Title>
              <Card.Text className={styles.description}>
                <Description description={description} />
              </Card.Text>
            </Card.Body>
            <div className={styles.container}>
              {!update &&
                (!userData || userData?.channelId !== channelId) &&
                isMemberShipEnabled && (
                  <p onClick={() => setShowLoginModal(true)} className={styles.signinMessage}>
                    {t("rates_table:discount")}
                  </p>
                )}
              <Accordion className={styles.details}>
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey="roomDetails"
                  onClick={handleRoomDetailsToggle}
                  className={`text-left fw-bold p-0 ${
                    roomDetailsExpanded ? `${styles.blues}` : "border-0 bg-transparent"
                  }`}
                >
                  <span className={`accordion-toggle-text ${styles.text}`}>
                    {roomDetailsExpanded ? (
                      <UpOutlined className="accordion-icon mr-2" />
                    ) : (
                      <RightOutlined className="accordion-icon mr-2" />
                    )}
                    Room Details
                  </span>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="roomDetails">
                  <Card.Body>
                    <RoomFacilities facilities={facilities} />
                  </Card.Body>
                </Accordion.Collapse>
              </Accordion>
            </div>
          </div>
        </div>

        <div className="">
          <Accordion activeKey="price">
            <Card>
              {sortedRates.length > 0 && (
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey="price"
                  // onClick={handlePriceToggle}
                  className={` ${styles.pricetoggle} ${
                    priceExpanded ? `${styles.blues}` : "border-0 bg-transparent"
                  }`}
                >
                  <span className={`accordion-toggle-text  ${styles.text}`}>
                    Starting from{" "}
                    {promotions?.length > 0 ? (
                      <>
                        <span
                          style={{ textDecoration: "line-through", marginLeft: 5, marginRight: 5 }}
                        >
                          {Math.min(
                            ...sortedRates.map((rate) => {
                              let totalTaxValue = 0;

                              rate.taxes.forEach((tax) => {
                                if (!tax?.inclusive) {
                                  totalTaxValue += parseFloat(tax?.amount);
                                }
                              });
                              return parseFloat(rate.totalPrice) - totalTaxValue;
                            }),
                          )}
                        </span>
                        {formatNumberWithDecimal(
                          applySequentialDiscounts(
                            Math.min(
                              ...sortedRates.map((rate) => {
                                let totalTaxValue = 0;

                                rate.taxes.forEach((tax) => {
                                  if (!tax?.inclusive) {
                                    totalTaxValue += parseFloat(tax?.amount);
                                  }
                                });
                                return parseFloat(rate.totalPrice) - totalTaxValue;
                              }),
                            ),
                            promotions,
                          )?.finalPrice,
                        )}
                      </>
                    ) : (
                      Math.min(
                        ...sortedRates.map((rate) => {
                          let totalTaxValue = 0;

                          rate.taxes.forEach((tax) => {
                            if (!tax?.inclusive) {
                              totalTaxValue += parseFloat(tax?.amount);
                            }
                          });
                          return parseFloat(rate.totalPrice) - totalTaxValue;
                        }),
                      ).toFixed(2)
                    )}{" "}
                    {currency}
                    {/* {priceExpanded ? (
                      <UpOutlined className="accordion-icon ml-2" />
                    ) : (
                      <DownOutlined className="accordion-icon ml-2" />
                    )} */}
                  </span>
                </Accordion.Toggle>
              )}

              <Accordion.Collapse eventKey="price">
                <Card.Body className="p-0">
                  {sortedRates.map((ratePlan) => {
                    return (
                      <Fragment key={ratePlan.id}>
                        <RatePlan
                          promotions={promotions}
                          disabled={disabled}
                          update={update}
                          disable={disable}
                          ratePlan={ratePlan}
                          currency={currency}
                          occupiedSpaces={occupiedSpaces}
                          ratesOccupancy={roomRates}
                          bookedRoomOccupancy={bookedRoomRates}
                          onOccupancyChange={handleRatesOccupancyChange}
                          adultsOccupancy={adultsOccupancy}
                          childrenOccupancy={childrenOccupancy}
                        />
                      </Fragment>
                    );
                  })}
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </div>
      </Card>
      {!sortedRates.length && <NoRatesPlaceholder />}
    </div>
  );
}
